<div [hidden]="!loading" class="spinner">
  <div class="sk-spinner sk-spinner-pulse"></div>
</div>
<app-table [rows]="rows" [columns]="columns" [actions]="tableActions" [batch]="true" (sort)="onSort($event)" (changeBatch)="onChangeBatch($event)"
  (action)="onAction($event)" (cellClick)="onCellClick($event)"></app-table>
<div class="d-flex justify-content-between align-items-center my-15 has-pagination">
  <div class="pagination-left">
    <app-pagination *ngIf="totalCount > currentSize" [totalItems]="totalCount" [currentPage]="page" (change)="onPageChange($event)"
      [pageSize]="currentSize"></app-pagination>
  </div>
  <div class="d-flex align-items-center justify-content-end pagination-right">
    <span class="pagination-count">Showing {{ rows.length }} of {{ totalCount }} numbers</span>
    <ul *ngIf="sizes.length" class="pagination">
      <li *ngFor="let size of sizes" [ngClass]="{ active: size === currentSize }">
        <a (click)="onChangeSize(size)">{{ size }}</a>
      </li>
    </ul>
  </div>
</div>

<ng-template #balanceModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block mb-0">Balance</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <app-appscripts-balance-card [balanceHistory]="currentBalanceHistory"/>
  </div>
</ng-template>

<ng-template #infoTransactionModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block mb-0">Transaction info</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body modal-details">
    <div class="modal-details__content">
      <div *ngIf="errorText" class="alert alert-danger modal-details__alert">
        {{ errorText }}
      </div>

      <section *ngIf="payoutPaypal" class="modal-details__section">
        <div class="modal-details__card">
          <div class="modal-details__header">
            <div>
              <h4 class="modal-details__title">PayPal payout</h4>
              <span *ngIf="payoutPaypal.transactionStatus" class="modal-details__subtitle">
                Status: {{ payoutPaypal.transactionStatus }}
              </span>
            </div>
            <span class="modal-details__badge modal-details__badge--paypal">PayPal</span>
          </div>

          <dl class="description-list modal-details__list">
            <dt class="text-muted">Payout item id</dt>
            <dd class="modal-details__value">{{ payoutPaypal.payoutItemId }}</dd>

            <dt class="text-muted">Payout item amount</dt>
            <dd class="modal-details__value">{{ payoutPaypal.amountVal }} {{ payoutPaypal.amountCurrency }}</dd>

            <dt class="text-muted">Payout item fee</dt>
            <dd class="modal-details__value">{{ payoutPaypal.payoutItemFeeVal }} {{ payoutPaypal.payoutItemFeeCurrency }}</dd>

            <ng-container *ngIf="payoutPaypal.transactionId">
              <dt class="text-muted">Transaction ID</dt>
              <dd class="modal-details__value">{{ payoutPaypal.transactionId }}</dd>
            </ng-container>

            <ng-container *ngIf="payoutPaypal.transactionStatus">
              <dt class="text-muted">Transaction status</dt>
              <dd class="modal-details__value">{{ payoutPaypal.transactionStatus }}</dd>
            </ng-container>
          </dl>

          <div *ngIf="payoutPaypal.errorName || payoutPaypal.errorMessage" class="alert alert-warning modal-details__note mb-0">
            <strong *ngIf="payoutPaypal.errorName" class="d-block">{{ payoutPaypal.errorName }}</strong>
            <span *ngIf="payoutPaypal.errorMessage" class="modal-details__value">{{ payoutPaypal.errorMessage }}</span>
          </div>
        </div>
      </section>

      <section *ngIf="payoutCrypto" class="modal-details__section">
        <div class="modal-details__card">
          <div class="modal-details__header">
            <div>
              <h4 class="modal-details__title">Crypto payout</h4>
              <span class="modal-details__subtitle">Crypto service</span>
            </div>
            <span class="modal-details__badge modal-details__badge--crypto">Crypto</span>
          </div>

          <dl class="description-list modal-details__list">
            <ng-container *ngIf="payoutCrypto.transactionUid">
              <dt class="text-muted">Transaction UID</dt>
              <dd class="modal-details__value">{{ payoutCrypto.transactionUid }}</dd>
            </ng-container>

            <dt class="text-muted">Transaction status</dt>
            <dd class="modal-details__value">{{ payoutCrypto.transactionStatus ? payoutCrypto.transactionStatus : 'N/A' }}</dd>

            <dt class="text-muted">Transaction fee</dt>
            <dd class="modal-details__value">
              {{ payoutCrypto.transactionFee !== null && payoutCrypto.transactionFee !== undefined ? payoutCrypto.transactionFee : 'N/A' }}
            </dd>

            <ng-container *ngIf="payoutCrypto.transactionHash">
              <dt class="text-muted">Transaction hash</dt>
              <dd class="modal-details__value">
                <ng-container *ngIf="payoutCrypto.transactionLink; else cryptoHashPlain">
                  <a [href]="payoutCrypto.transactionLink" target="_blank" rel="noopener" class="modal-details__link">
                    {{ payoutCrypto.transactionHash }}
                  </a>
                </ng-container>
                <ng-template #cryptoHashPlain>{{ payoutCrypto.transactionHash }}</ng-template>
              </dd>
            </ng-container>

            <ng-container *ngIf="payoutCrypto.transactionLink">
              <dt class="text-muted">Explorer link</dt>
              <dd class="modal-details__value">
                <a [href]="payoutCrypto.transactionLink" target="_blank" rel="noopener" class="modal-details__link">
                  {{ payoutCrypto.transactionLink }}
                </a>
              </dd>
            </ng-container>
          </dl>
        </div>
      </section>

      <div *ngIf="!payoutPaypal && !payoutCrypto && !errorText" class="modal-details__empty text-center text-muted">
        No transaction details available yet.
      </div>
    </div>
  </div>
</ng-template>

<ng-template #deleteModalTpl let-dialogRef="dialogRef">
  <deletemodal [dialogRef]="dialogRef"></deletemodal>
</ng-template>

<ng-template #commentModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Comment</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <textarea class="form-control comment mb-20" [(ngModel)]="commentText"></textarea>
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between align-items-center">
      <button class="btn btn-outline-dark px-20" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary px-20" (click)="onCommentSave()" [disabled]="loading">Save</button>
    </div>
  </div>
</ng-template>
